import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LocaleProvider } from "@/i18n";
import ScrollToTop from "@/components/ScrollToTop";
import { lazy, Suspense } from "react";

// Eager-load the homepage for instant first paint
import Index from "./pages/Index";

// Lazy-load all other pages for smaller initial bundle
const About = lazy(() => import("./pages/About"));
const Services = lazy(() => import("./pages/Services"));
const Methodology = lazy(() => import("./pages/Methodology"));
const EmployeMystere = lazy(() => import("./pages/EmployeMystere"));
const Contact = lazy(() => import("./pages/Contact"));
const Blog = lazy(() => import("./pages/Blog"));
const BlogArticle = lazy(() => import("./pages/BlogArticle"));
const Cities = lazy(() => import("./pages/Cities"));
const CityPage = lazy(() => import("./pages/CityPage"));
const FAQ = lazy(() => import("./pages/FAQ"));
const MentionsLegales = lazy(() => import("./pages/MentionsLegales"));
const PolitiqueConfidentialite = lazy(() => import("./pages/PolitiqueConfidentialite"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const routeDefinitions = [
  { path: "", element: <Index /> },
  { path: "a-propos", element: <About /> },
  { path: "services", element: <Services /> },
  { path: "methodologie", element: <Methodology /> },
  { path: "employe-mystere", element: <EmployeMystere /> },
  { path: "contact", element: <Contact /> },
  { path: "blog", element: <Blog /> },
  { path: "blog/:slug", element: <BlogArticle /> },
  { path: "audit-mystere", element: <Cities /> },
  { path: "audit-mystere/:slug", element: <CityPage /> },
  { path: "faq", element: <FAQ /> },
  { path: "mentions-legales", element: <MentionsLegales /> },
  { path: "politique-de-confidentialite", element: <PolitiqueConfidentialite /> },
];

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <LocaleProvider>
            <ScrollToTop />
            <Suspense fallback={<div className="min-h-screen bg-background" />}>
              <Routes>
                {/* French routes (default) */}
                {routeDefinitions.map(({ path, element }) => (
                  <Route key={`fr-${path}`} path={`/${path}`} element={element} />
                ))}
                {/* English routes (prefixed with /en) */}
                {routeDefinitions.map(({ path, element }) => (
                  <Route key={`en-${path}`} path={`/en/${path}`} element={element} />
                ))}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </LocaleProvider>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
